module.exports = __webpack_public_path__ + "static/media/inktoberTrickOrTreat.71a34099.gif";